// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-role=log-interaction-form] .label-header{margin-top:5px}[data-role=log-interaction-form] .interaction-type-radio{display:inline-block;width:33%}[data-role=log-interaction-form] .interaction-type-radio input[type=radio]{margin-right:10px}[data-role=log-interaction-form] .interaction-type-radio label{font-weight:300}[data-role=log-interaction-form] textarea{resize:vertical !important}", ""]);
// Exports
module.exports = exports;
